import axios from "axios";
import { ROOT_URL } from "../../../config/url";
import type { TurnoverResponse } from "./turnovers-types";

function getHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("tokenSession"),
  };
}

const api = axios.create({ baseURL: ROOT_URL, withCredentials: false });

export function getTurnovers(): Promise<TurnoverResponse> {
  return api
    .get("/api/admin/turnovers", { headers: getHeaders() })
    .then((res) => res.data);
}
